// Small helpers shared by B2B / B2C pages

// Convert a backend file path (or relative) to a public URL
export function fixImageUrl(raw) {
  if (!raw) return undefined;
  const s = String(raw).replace(/\\/g, "/").trim();
  if (/^https?:\/\//i.test(s)) return s;
  if (!s.startsWith("/")) return `/uploads/${s}`;
  return s;
}

// Prefer server-provided absolute URL on first image
export function firstDbImage(p) {
  if (!Array.isArray(p?.images) || p.images.length === 0) return undefined;
  const first = p.images[0];
  const raw = first?.url || first?.image;
  return fixImageUrl(raw);
}

// Normalize a product for the card component
export function normalizeProductForCard(p) {
  const productID = p?.productID ?? p?.id ?? String(p?.sku ?? "");
  const parentID  = p?.parentID ?? null;

  const productName =
    p?.productName ??
    p?.info?.name ??
    p?.ProductInfo?.name ??
    p?.main?.name ??
    p?.name ??
    productID;

  const image =
    firstDbImage(p) ||
    fixImageUrl(p?.imageUrl) ||
    fixImageUrl(p?.image) ||
    fixImageUrl(p?.thumbnail);

  const brandLine =
    p?.Brand?.brandName ??
    p?.Brand?.brandID ??
    p?.brandName ??
    p?.brand ??
    p?.brandID ??
    "";

  const price =
    typeof p?.info?.productPrice === "number" ? p.info.productPrice :
    typeof p?.ProductInfo?.productPrice === "number" ? p.ProductInfo.productPrice :
    typeof p?.price === "number" ? p.price : 0;

  const categoryHref = p?.categoryHref || p?.Category?.href || p?.Categories?.href || "";

  const normalizedImages = Array.isArray(p?.images)
    ? p.images.map((img) => fixImageUrl(img?.url || img?.image)).filter(Boolean)
    : [];

  return {
    ...p,
    productID,
    parentID,
    productName,
    title: productName,
    name: productName,
    subtitle: brandLine,
    brand: brandLine,
    brandName: brandLine,
    price,
    image,
    img: image,
    imageUrl: image,
    thumbnail: image,
    images: normalizedImages,
    categoryHref,
  };
}
